<template>
  <div v-if="assets.length > 0" class="sds overflow-hidden rounded-md border border-solid border-[--color-neutral-a4]">
    <div
      class="font-medium leading-6 [&_>div:first-child]:border-0 [&_>div:last-child]:border-0 [&_>div]:flex [&_>div]:justify-between [&_>div]:gap-4 [&_>div]:border-b [&_>div]:border-[--color-neutral-a4] [&_>div]:px-5 [&_>div]:py-3 [&_>div]:font-bold"
    >
      <div v-if="!displayDownloadButton" class="bg-[--color-neutral-a6] !py-[14px]">
        <h3 class="m-0 text-lg font-semibold text-[--color-neutral-a05] lg:text-xl">
          {{ $t("pages.product.documents.safety_data_sheets") }}
        </h3>
      </div>
      <div v-for="(document, index) in props.assets" :key="index" class="sds__item flex items-center">
        <div>
          <span>{{ getFileName(document.description) }}</span>
        </div>
        <button
          type="button"
          class="font-medium text-[--color-link] hover:text-[--color-neutral-a1]"
          :aria-label="$t('pages.product.documents.open')"
          @click="openFile(document.optiUrl, getOpenFileName(document.description, document.name))"
        >
          {{ $t("pages.product.documents.open") }}
        </button>
      </div>
    </div>
  </div>
  <VcButton
    v-if="displayDownloadButton"
    class="w-full"
    variant="outlineTL"
    color="secondary"
    size="lg"
    @click="downloadSDSDocsAsZip"
  >
    <VcIcon name="download" :size="20" class="mr-2.5 mt-1" />
    {{ $t("pages.product.documents.download_all") }}
  </VcButton>
</template>

<script lang="ts" setup>
import { getFileExtension } from "../../shared";
import { downloadFile, openFile } from "../types";
import type { Asset } from "@/core/api/graphql/types";

interface IProps {
  assets: Asset[];
  displayDownloadButton: boolean;
  productId: string;
}

const props = defineProps<IProps>();

const getFileName = (name: string | undefined) => {
  if (name) {
    return name;
  } else {
    return "File";
  }
};

const getOpenFileName = (description: string | undefined, name: string | undefined) => {
  if (description) {
    return `${description.replace(" ", "-")}.${getFileExtension(name)}`;
  }
  return "File";
};

const downloadSDSDocsAsZip = async () => {
  await downloadFile(
    `/api/thorlabs-products/sds-zip/${props.productId}`,
    "SDS Files.zip",
    {
      responseType: "arraybuffer",
    },
    { type: "application/zip" },
  );
};
</script>
